<template>
  <button @click="openScanner" class="btn btn--primary w-100">
    Open scanner
    <img src="../assets/images/event/icon-scan.svg" alt="Scan" class="ms-1" />
  </button>
</template>

<script>
export default {
  name: "ScanButtonComponent",
  props: {
    EventId: String,
    ProgramId: String,
    Scanning: String,
  },
  methods: {
    openScanner() {
      let scanInfo = {
        scanning: this.Scanning,
        eventId: this.EventId,
        programId: this.ProgramId,
      };

      this.$store.commit("setScanInfo", {
        scanInfo: scanInfo,
      });

      this.$router.push("/scanner");
    },
  },
};
</script>
